window.$ = require("jquery");
window.jQuery = window.$;
window._ = require("underscore");
require("./plugins/ajaxzip2");

require("materialize-css");

AjaxZip2.JSONDATA = window.APP_ROOT + '/assets/data';

$(document).ready(function () {

    $(".button-collapse").sideNav();

    $('.modal-trigger').leanModal();

    $('select').material_select();

    $('#code1, #code2').on("keyup", function () {
        AjaxZip2.zip2addr('code1','address1', 'address1', 'code2');
    });

    var $submit_btns = $("button[form]");

    /* submitした時の挙動 */
    $submit_btns.on("click", function (evt) {
        evt.preventDefault();
        var $elem = $(this);
        var target_form_id = $elem.attr("form");
        var $target_form = $("#" + target_form_id);

        // ボタン要素にvalとname属性があればそれを追加
        var name = $elem.attr("name");
        var val = $elem.attr("value");
        if (name) {
            $target_form.append($("<input>", { type: "hidden", name: name, value: val }));
        }

        $target_form.submit();
    });

});

/**
 *
 * 食事条件の制限
 *
 **/
(function ($, window, _) {

    var $radio_items = $(".radio-list__item.js-room-item");

    $radio_items.on("change", function (evt) {

        var $elem = $(this);
        var $input = $elem.find("input");
        var val = $input.val();
        var target = $input.data("room-date");

        resetAll(target);
        checkAll(target, val);


    });

    function checkAll (target, val) {

        var $input = $("input[data-room-date='" + target + "'][value='" + val + "']");
        $input.prop("checked", "checked");

    }

    function resetAll (target) {

        var $input = $("input[data-room-date='" + target + "']");
        $input.prop("checked", "");

    }


})(jQuery, window, _);

/**
 *
 * 数値のチェック
 *
 */
(function ($, window, _) {

    var $modal_no_room_selected = $("#modal-no-room-selected");
    var $modal_temporary_reservation = $("#modal-temporary-reservation");
    var $room_number = $(".js-room-number");
    var $reservation_btn = $(".js-check-reservation");

    /**
     *
     * 数値を指定していない場合のエラー処理
     *
     */
    $reservation_btn.on('click', function (evt) {

        evt.preventDefault();

        var result = false;

        $room_number.each(function() {

            var $elem = $(this);
            var val = parseInt($elem.find("option:selected").val());

            if (val !== 0) {

                result = true;
            }

        });

        // 全て0ならアラートを表示
        if (!result) {

            $modal_no_room_selected.openModal();

        } else {
            $modal_temporary_reservation.openModal();
        }

    });

})(jQuery, window, _);

/**
 *
 * キャンセル時の銀行口座振込入力のチェック
 *
 */
(function ($, window, _) {

    var $cancel_form = $("#cancel_submit");
    var $cancel_btn = $(".js-purchase-cancel-btn");
    var $cancel_modal = $("#modal-purchase-cancel");
    var $cancel_required_modal = $("#modal-purchase-cancel-required");

    var required = [ "bank_name", "branch_name", "bank_type", "account_name", "account_number" ];
    var error_text = {
        bank_name: "銀行名を入力してください",
        branch_name: "支店名を入力してください",
        bank_type: "口座種別を選択してください",
        account_name: "口座名義を入力してください",
        account_number: "口座番号を入力してください"
    };


    $cancel_btn.on("click", function (evt) {
        var form_data = $cancel_form.serializeArray();
        var error = false;
        var text = "";
        _.each(form_data, function ( val ) {

            var name = val.name;
            if (_.contains(required, name)) {

                // 入力がない場合は
                if (!val.value) {
                    error = true;
                    text += error_text[name] + "<br><br>";
                }

            }

        });

        if (error) {

            $cancel_required_modal.find("p.center").html(text);
            $cancel_required_modal.openModal();

        } else {

            $cancel_modal.openModal();

        }

    });

})(jQuery, window, _);


/**
 *
 * モーダルの表示
 *
 */
(function ($, window, _) {

    if (SUCCESS) {

        $("#modal-success").openModal();

    }

})(jQuery, window, _);


/**
 *
 * 日程ホテルの在庫一覧の取得
 *
 */
(function ($, window, _) {


    var modal; // モーダルのグローバルオブジェクト
    var collection; // 日程ホテルデータを格納するグローバルオブジェクト
    var url_root = APP_ROOT + "/public/api/schedule_stock/";
    var action_type;
    var current_target_id;
    var modal_template;

    /**
     * 指定した日程ホテルIDを元に、現在の部屋タイプ・在庫数を返却する
     * @param target_id
     * @param type
     */
    function get (target_id, type) {

        var url;

        // タイプを更新
        action_type = type;

        /**
         * APIのURLを作成
         */
        switch (action_type) {
            case "schedule_hotel":
                url = url_root + target_id + "/";
                break;
            case "schedule":
                url = url_root + "schedule/" + target_id + "/";
                break
        }


        return $.get(url, {
            nonce: AJAX_Nonce
        })
            .done(function (resp) {

                //console.log("成功しました");
                //console.log(resp);
                /**
                * jsonデータを取得
                */
                collection = resp.collection;
                //console.log(collection);

                /**
                * Ajax通信用のXSS対策キーを更新
                */
                AJAX_Nonce = resp.nonce;
                //console.log(AJAX_Nonce);

            })
            .fail(function (resp) {

                console.log("失敗しました");
                console.log(resp);

                return false;

            });

    }

    /**
     *
     * レンダリングを実行する
     *
     */
    function render () {

        // もしmodalが存在すれば削除する
        modal.empty();

        modal.append(modal_template({
            type: action_type,
            collection: collection,
            login_status: Login,
            root: GROUP_ROOT,
            can_reserve: CAN_RESERVE
        }));

        modal.find(".modal").openModal();

    }


    // 実行
    $(document).ready(function () {

        /**
         * モーダル表示ボタン
         * @type {*|HTMLElement}
         */
        var $btn = $(".js-stock-modal");

        /**
         * テンプレートを取得
         */
        modal_template = _.template($("#template-schedule-hotel-list").html());

        /**
         * プレースホルダーを作成
         */
        modal = $("<div />");

        // プレースホルダーをbodyに設置
        $('body').append(modal);


        $btn.on("click", function (evt) {

            var $elem = $(this);
            var target_id = $elem.data("target-id");
            var type = $elem.data("type");

            get(target_id, type)
                .done(function () {
                    render();
                })



        })

    });


})(jQuery, window, _);

/**
 * トップへ戻るボタンの表示設定
 */
(function ($, window, _) {

    var scrollTop;
    var showPosition = 400;
    var $window;
    var $topBtn;
    var timer;
    var visible = false;

    /**
     * スクロールトップを取得する
     */
    function getScrollTop () {
        scrollTop = $window.scrollTop();
    }

    /**
     * ボタンの表示・非表示を切り替える
     */
    function toggleTopBtn () {

        getScrollTop();

        if (scrollTop > showPosition && !visible) {
            visible = true;
            $topBtn.removeClass("hide");
        }

        if (scrollTop < showPosition && visible) {
            visible = false;
            $topBtn.addClass("hide");
        }

    }

    /**
     * 実行・イニシャライズ
     */
    $(document).ready(function() {

        $window = $(window);
        $topBtn = $('#back-to-top');

        toggleTopBtn();

        $(window).scroll(function () {

            if (timer) clearTimeout(timer);

            setTimeout(function () {

                toggleTopBtn();

            }, 200)

        })

    });



})(jQuery, window, _);


/*****************
 ** WEBPACK FOOTER
 ** ./dev/assets/js/app.js
 ** module id = 0
 ** module chunks = 0
 **/